import { call } from 'redux-saga/effects';

import { ISubscriptionWellfunnel } from 'api/components/Subscriptions/types';
import api from 'api';

import {
    sendAnalyticFrontCancelSubscriptionRequest,
    sendAnalyticSubscriptionCancelError,
    sendAnalyticSubscriptionCancelSuccess,
} from 'services/Analytics';

import { handleAuthError } from './utils';

export function* callUnsubscribe(
    currentSubscription: ISubscriptionWellfunnel,
    successCount?: { current: number },
    errorCount?: { current: string[] }
) {
    try {
        sendAnalyticFrontCancelSubscriptionRequest();

        yield call(api.subscriptions.unsubscribe, {
            id: currentSubscription.external_id,
            provider: currentSubscription.payment_provider,
        });

        sendAnalyticSubscriptionCancelSuccess(currentSubscription.external_id);

        if (successCount) {
            successCount.current += 1;
        }
    } catch (error) {
        const authErrorWasHandled = yield* handleAuthError(error);

        if (authErrorWasHandled) return;

        if (errorCount) {
            errorCount.current.push(currentSubscription.external_id);
        }

        sendAnalyticSubscriptionCancelError(currentSubscription.external_id);

        throw new Error('Subscription is not cancelled');
    }
}
